//引入公共API
import commonApi from './common/api';

// 自动导入model下所有ts结尾的接口文件
const contextModel = require.context('./model', true, /.ts$/)
const apiImportList: any[] = contextModel.keys().map(context => {
    const apiImport = contextModel(context)
    return apiImport.default || apiImport
})


const apis: any = Object.assign(
    commonApi,
    ...apiImportList
);

export default apis;